import AddFunderDialog from "@/dashboard/components/fundings/AddFunderDialog";
import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const ProjectInput: FC<{
  handleChange: (value) => void;
  selected?: any;
  className?: string;
  idFinancer: number | null;
  disableProject:boolean;
  isFromIntervenant?: boolean;
}> = ({ handleChange, selected = null, className = "" , idFinancer = null, disableProject = true, isFromIntervenant = false}) => {
  
  const { t } = useTranslation("dashboard", {
    keyPrefix: "certificats",
  });
  
  const [query, setQuery] = useState("");
  const [forAdd, setForAdd] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(selected);
  const [openAddProject, setOpenAddProject] = useState(false);

  useEffect(() => {
      setQuery("");
      setForAdd("");
      setResults([]);
      setLoading(false);
      setSelectedOption(null);
  }, [idFinancer]);

  useEffect(() => {
    if(query !== "") {
      setForAdd(query);
    }

    if (query.length < 3) {
      setResults([]);
      return;
    }

    const fetchResults = async () => {
      setLoading(true);
      let token = localStorage.getItem("jwtToken");
      if(token === null) {
        token = sessionStorage.getItem("jwtToken");
      }
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_ENDPOINT}/projects-without-certificate?s=${query}&financer=${idFinancer}&isFromIntervenant=${isFromIntervenant ? 'true' : 'false'}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        setResults(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des résultats :", error);
        setResults([]);
      } finally {
        setLoading(false);
      }
    };

    const delayDebounceFn = setTimeout(() => {
      fetchResults();
    }, 300); // Attente de 300ms pour éviter les appels API excessifs

    return () => clearTimeout(delayDebounceFn);
  }, [query]);

  const addItem = (item) => {
    setSelectedOption(item);
    setQuery(""); // Réinitialise le champ d'entrée
    setResults([]); // Vide les résultats affichés
    handleChange(item);
  };

  useEffect(() => {
    if(isFromIntervenant == false) {
      if(openAddProject) {
        document.getElementById('addFinancementContent').style.opacity = '0.4';
      } else {
        document.getElementById('addFinancementContent').style.opacity = '1';
      }
    }
  }, [openAddProject])

  return (
    <>
    <div className={"mx-auto w-full " + className}>
      <input
        type="text"
        value={query === "" && selectedOption !== null ? selectedOption.name : query}
        onChange={(e) => {
            if(e.target.value === "") {
                setQuery("");
                setForAdd("");
                setResults([]);
                setLoading(false);
                setSelectedOption(null);
                handleChange(null);
            } else { 
                setQuery(e.target.value)
            }
        }}
        onBlur={() =>
          setTimeout(() => {
            setResults([]);
            setQuery("");
          }, 200)
        }
        disabled={disableProject}
        placeholder={t("Commencez à saisir le nom d'un projet...")}
        className="border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      />
      {loading && <p className="mt-2 text-sm text-gray-500">Chargement...</p>}
      {!loading && query && (
        <ul className="posi mt-2 max-h-60 overflow-y-auto rounded-md border border-gray-300 bg-white shadow-lg">
          {/* Ajouter comme nouveau */}
          {results.map(
            (result, index) => (
              <li
                  key={index}
                  className="flex cursor-pointer gap-2 border-b px-4 py-2 last:border-b-0 hover:bg-blue-100"
                  onClick={() => {
                    addItem(result);
                  }}
                >
                  <span>{result.name}</span>
                </li>
            )
          )}
        </ul>
      )}
      
    </div>

    {/* <AddFunderDialog
      hasTrigger={false}
      open={openAddProject}
      onHandleOpen={setOpenAddProject}
      onSaveSuccess={(res) => {
        addItem(res);
        setOpenAddProject(false);
      }}
      data={{
        name: forAdd,
      }}
    /> */}
    </>
  );
};

export default ProjectInput;
